module.exports = {
  input: require('./input'),
  output: require('./output')
}



//////////////////
// WEBPACK FOOTER
// ./~/bitcoinjs-lib/src/templates/witnessscripthash/index.js
// module id = 392
// module chunks = 0